import UpdateUserConfigurationJsonResponse from 'owa-service/lib/contract/UpdateUserConfigurationJsonResponse';
/* tslint:disable:restrict-import-path */
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
/* tslint:enable:restrict-import-path */
import { select } from 'satcheljs/lib/legacy';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';

export interface UpdateGlobalFolderViewStateState {
    viewState: string;
}

export default select({
    viewState: () => getUserConfiguration().ViewStateConfiguration.GlobalFolderViewState,
})(function updateGlobalFolderViewState(
    state?: UpdateGlobalFolderViewStateState
): Promise<UpdateUserConfigurationJsonResponse> {
    return updateUserConfiguration('OWA.ViewStateConfiguration', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['GlobalFolderViewState'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'String',
                Value: [state.viewState],
            }),
        }),
    ]);
});
